import { type EmbedTarget } from '../embed-targets/embed-target'
import { type EmbedStrategy } from './embed-strategy'

export interface EmbedStrategyFactory {
  create (target: EmbedTarget): EmbedStrategy
}

export interface EmbedStrategyFactoryRegistry {
  register (name: string, factory: EmbedStrategyFactory): void
  unregister (name: string): void
  get (name?: string): EmbedStrategyFactory | undefined
}

export class DefaultEmbedStrategyFactoryRegistry implements EmbedStrategyFactoryRegistry {
  #registry = new Map<string, EmbedStrategyFactory>()

  register (name: string, factory: EmbedStrategyFactory): void {
    this.#registry.set(name, factory)
  }

  unregister (name: string): void {
    this.#registry.delete(name)
  }

  get (name?: string): EmbedStrategyFactory | undefined {
    if (name == null) return undefined
    return this.#registry.get(name)
  }
}
